import { Vertical } from 'component/Vertical'
import { MeasurementsBanner } from 'feature/measurements/MeasurementsBanner'
import { measurements_banner, useMeasurementsBanner } from 'feature/measurements/store'
import { PersonalizeBanner } from 'feature/personalize/PersonalizeBanner'
import { personalize_banner, usePersonalizeBanner } from 'feature/personalize/store'
import { SizesBanner } from 'feature/sizes/SizesBanner'
import { sizes_banner, useSizesBanner } from 'feature/sizes/store'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { GenerationsEmptyScreen } from 'page/GenerationsScreen/GenerationsEmptyScreen'
import { BottomPanel } from 'page/InferenceScreen/BottomPanel'
import { BuyBanner } from 'page/InferenceScreen/buy/BuyBanner'
import { Carousel2 } from 'page/InferenceScreen/Carousel/Carousel2'
import { FeedbackBanner } from 'page/InferenceScreen/FeedbackBanner'
import { ImageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModal'
import { imageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModalStore'
import { LookyQr } from 'page/InferenceScreen/LookyQr'
import { MessagePanel } from 'page/InferenceScreen/MessagePanel'
import { LoadingPage } from 'page/LoadingPage'
import { Page } from 'page/Page/Page'
import { UserDataBanner } from 'page/UserDataBanner/UserDataBanner'
import { ActionsBanner } from 'shared/inference/ActionsBanner'
import { ShareBanner2 } from 'shared/inference/ShareBanner2'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'
import css from './InferenceScreen.module.scss'

export const InferenceScreen = observer(() => {
  const { busy, buy } = store.inferences
  const { item } = store.carousel.carousel

  usePersonalizeBanner(item)
  useMeasurementsBanner()
  useSizesBanner()

  const onBack = useLatestCallback(async () => {
    if (store.comboItem) {
      store.screen = 'start'
    } else if (opt.tsum) {
      controller.openStart()
    } else {
      controller.openGenerations()
    }
  })

  if (busy) return <LoadingPage start />

  if (!item) return <GenerationsEmptyScreen />

  return (
    <Page full onBack={onBack} center>
      <Vertical className={css.content} gap={16}>
        <Vertical className={css.center}>
          <Carousel2 />
          <MessagePanel />
        </Vertical>
        <Vertical className={css.bottom}>
          <BottomPanel inference={item} />
        </Vertical>
      </Vertical>

      <FeedbackBanner />
      <ActionsBanner />
      <ShareBanner2 />
      <LookyQr />
      <UserDataBanner />
      {buy && <BuyBanner />}
      {imageQrModal.present && <ImageQrModal />}
      {personalize_banner.present && <PersonalizeBanner />}
      {measurements_banner.present && <MeasurementsBanner save />}
      {sizes_banner.present && <SizesBanner />}
    </Page>
  )
})
